import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
class InternalProvidersDossiersPanel extends Component {
    constructor(props) {
        super();
        this.state = {
            dossiers: [],
            total:0,
            statuses: [],
            status: null,
            maxRecords: props.top,
            page: 1,
            search:'',
            orderBy : {value: 'date', dir: 'desc', text: 'Por fecha - Mas Recientes' },
            orderOptions : [
                {value: 'date', dir: 'desc', text: 'Por fecha - Mas Recientes' },
                {value: 'date', dir: 'asc', text: 'Por Fecha - Mas Antiguos' },
                {value: 'fiscal_name', dir: 'asc', text: 'Por Nombre A - Z' },
                {value: 'fiscal_name', dir: 'desc', text: 'Por Nombre Z - A' },
            ],
        };
        this.loadStatus = this.loadStatus.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.getStatuses()
        this.getAll()
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getAll();
        });
    }

    handleChange(e){
        this.setState({all: [], search: e.target.value, page: 1}, function () {
            this.getAll();
        });
    }

    async getStatuses(){
        const res = await axios.get('/api/dossiers/status')
        const data = res.data;
        this.setState({statuses: data});

        var statusDossiers = [];
        this.state.statuses.map((s) => {
            statusDossiers = [...statusDossiers, []];
        });
        this.setState({statusDossiers: statusDossiers})
    }

    loadStatus(index){
        const status = this.state.statuses[index];
        this.setState({all: [], page: 1, status: status.id}, () => {
            this.getAll();
        });
    }

    showAll(){
        this.setState({all: [], page: 1, status: null, index: null}, () => {
            this.getAll();
        });
    }

    async getAll(){
        var url = '/api/clients/dossiers/internals';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        if(this.state.status!=null){
            query.append('status', this.state.status);
        }

        if(this.state.orderBy.value != ''){
            query.append('orderBy', this.state.orderBy.value);
            query.append('orderByDir', this.state.orderBy.dir);
        }

        if(this.state.status!=null){
            query.append('status', this.state.status);
        }
        const qs = query.toString();
        url = url + `?${qs}`;
        url = url.endsWith('/') ? url.slice(0, -1) : url;
        const res = await axios.get(url);
        const data = res.data; 
        this.setState({dossiers: data.dossiers.data, total: res.data.total});
    }

    getDossierTypeColor(type_id){
        if(type_id == 1) return 'danger'; // Nacional
        if(type_id == 2) return 'success'; // Internacional
        if(type_id == 3) return 'info'; // Especiales
        if(type_id == 4) return 'warning'; // Otros
    }

    render() {
        return (
            <>
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">Expedientes de Invitados Internos</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">{this.state.total} expedientes</span>
                    </h3>
                    <div className="card-toolbar">
                        <div>
                            {this.props.dashboard=="false" &&
                                <div className="input-icon mb-4">
                                    <input
                                        onChange={this.handleChange}
                                        name="search"
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar expedientes" />
                                    <span>
                                        <i className="flaticon2-search-1 text-primary icon-md"></i>
                                    </span>
                                </div>
                            }
                            <ul className="nav nav-pills nav-pills-sm nav-dark">
                                <li className="nav-item ml-0">
                                    <a href={"#ts_all"} className={`nav-link py-2 px-4 font-weight-bolder font-size-sm ${this.state.status==null ? "active" : ""}`} onClick={() => this.showAll()} >Todos</a>
                                </li>
                                {this.state.statuses.map((status, i) => {
                                    return <li key={i} className="nav-item ml-0" onClick={() => this.loadStatus(i)} >
                                        <a href={"#ts_" + i } className={`nav-link py-2 px-4 font-weight-bolder font-size-sm ${this.state.status==status.id ? "active" : ""}`}>{ status.name }</a>
                                    </li>
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card-body pt-1">
                <div className="table-responsive">
                        <table className="table table-borderless table-vertical-center">
                            <tbody>
                                {this.state.dossiers.map((dossier, index) => {
                                    return <tr key={index}>
                                        <td className="pl-0 py-5">
                                            <div className="symbol symbol-40">
                                                <div className={"symbol-label text-white font-weight-bolder bg-"+this.getDossierTypeColor(dossier.dossier?.dossier_type_id)}>
                                                    {   dossier.dossier?.target.name[0]   }
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/internals/dossiers/" + dossier.internal_provider_batch_file.id}>
                                                <div className="text-dark-75 font-weight-bolder font-size-lg">
                                                    { dossier.provider != null ? dossier.provider.fiscal_name : dossier.name }
                                                </div>
                                                <span className="text-dark-50 font-weight-bold">{dossier.dossier.title} </span>
                                                <br/>
                                                <span className="text-muted font-weight-bold font-size-sm">
                                                    <span className={'badge badge-'+dossier.dossier_status.name.toString().toLowerCase()}>{dossier.dossier_status.name}</span>

                                                </span>

                                            </a>
                                            { dossier.transfer == true  &&
                                                        <a className="text-dark-50 font-size-sm a-underline mr-10" href={'/clients/dossiers/'+dossier.invitation_id}>En transferencia </a>  }
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/internals/dossiers/" + dossier.internal_provider_batch_file.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">
                                                    {dossier.totalDocuments}
                                                </div>
                                                <span className="text-muted font-weight-bold">Total de Documentos</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/internals/dossiers/" + dossier.internal_provider_batch_file.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{dossier.pending} </div>
                                                <span className="text-muted font-weight-bold">Pendientes</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/internals/dossiers/" + dossier.internal_provider_batch_file.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg"> {dossier.loaded} </div>
                                                <span className="text-muted font-weight-bold">Cargados</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/internals/dossiers/" + dossier.internal_provider_batch_file.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg"> {dossier.approved} </div>
                                                <span className="text-muted font-weight-bold">Aprobadas</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/internals/dossiers/" + dossier.internal_provider_batch_file.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg"> {dossier.rejected} </div>
                                                <span className="text-muted font-weight-bold">Rechazados</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/internals/dossiers/" + dossier.internal_provider_batch_file.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg"> {dossier.expired} </div>
                                                <span className="text-muted font-weight-bold">Historial</span>
                                            </a>
                                        </td>
                                        <td className="text-right">
                                            <a href={"/clients/internals/dossiers/" + dossier.internal_provider_batch_file.id}>
                                                <button className="btn btn-icon btn-light btn-xs">
                                                    <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                </button>
                                            </a>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                    { this.props.dashboard == "true" ?
                        <div className="text-right">
                            <a href="/clients/internals/dossiers">Ver todos</a>
                        </div>
                    :
                        <div></div>
                    }
                </div>
                {this.state.total > this.state.maxRecords && this.props.dashboard=="false" &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }
            </div>
            </>
        );
    }
}

export default InternalProvidersDossiersPanel;

if (document.getElementById('InternalProvidersDossiersPanel')) {
    ReactDOM.render(<InternalProvidersDossiersPanel />, document.getElementById('InternalProvidersDossiersPanel'));
}
